import React from 'react';
import { useTheme } from '@mui/material';

import { ContentPageHeader } from 'web-components';
import T from 'prop-types';

import { ContentWrapper } from 'elements';
import { ROUTE_MACHINES } from 'attrs/routePaths';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import MachineDetailsContent from 'containers/Machines/MachinesDetail/MachineDetailsContent';
import EditMachineDetails from 'containers/Machines/MachinesDetail/EditMachineDetails';
import { DetailsWrapper } from './MachinesOverviewDetails.styled';
import { BatchResponse } from '../../helpers/propTypes';
import { showMachineEditModal } from '../../redux/machines/actions';
import { getShowMachineEditModal } from '../../redux/machines/selectors';
import { MACHINE_STATUS_TRACKED, MACHINE_STATUS_UNTRACKED } from '../MachineTrackStatusIcon/MachineTrackStatusIcon';

const MachinesOverviewDetails = ({ machine }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const data = machine;
  const isOpen = useSelector(getShowMachineEditModal);
  const title = t('machines.detail.title');
  const name = data?.commission_number ? `${data.commission_number} ${title}` : title;
  // TODO: don't know what is the purpose of this line check with the team
  const isTracked = data.name !== '' && data.production_line !== '' ? MACHINE_STATUS_TRACKED : MACHINE_STATUS_UNTRACKED;
  // TODO: not asked to have access controll check with the team
  // const role = useSelector(getUserRole);
  // const batchEnabled = true;
  // const fullEdit = role.includes(ROLE_MANAGER) && batchEnabled;

  const handleCloseEditMachineModal = () => {
    dispatch(showMachineEditModal(false));
  };

  return (
    <>
      <ContentWrapper maxWidth={false}>
        <ContentPageHeader header={name} backUrl={`/${ROUTE_MACHINES}`} consistentHeight />
        <DetailsWrapper theme={theme}>
          <MachineDetailsContent machine={{ ...data, isTracked }} />
        </DetailsWrapper>
      </ContentWrapper>
      <EditMachineDetails handleClose={handleCloseEditMachineModal} open={isOpen} machineDetail={data} />
    </>
  );
};

MachinesOverviewDetails.propTypes = {
  machine: T.shape(BatchResponse).isRequired
};

export default MachinesOverviewDetails;
